import TopLocationSuburb from './TopLocationSuburb';

export default TopLocationSuburb;
